var _path, _path2, _circle, _circle2, _circle3, _g, _path3, _path4, _g2, _path5, _path6, _g3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecondSectionGraphic(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 301,
    height: 483,
    viewBox: "0 0 301 483",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M236.082 99.2851C236.082 80.4416 220.941 65.1266 202.228 65.1266L202.228 -4.33989e-06C256.581 -1.9427e-06 300.629 44.4437 300.629 99.2851C300.629 154.127 256.581 198.57 202.228 198.57L202.228 133.444C220.903 133.444 236.082 118.166 236.082 99.2851Z",
    fill: "#54AD47"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M102.639 380.386L166.883 380.386C166.883 436.641 121.683 482.293 65.8829 482.293L65.8829 417.472C86.1655 417.472 102.639 400.851 102.639 380.386Z",
    fill: "#FFCE1B"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 267.5,
    cy: 394.176,
    r: 19.5,
    fill: "#3091D0"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 349.176,
    r: 45.5,
    fill: "#6F368B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_475_20666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 303,
    width: 91,
    height: 92
  }, _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45.5,
    cy: 349.176,
    r: 45.5,
    fill: "#6F368B"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_475_20666)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 83.1602 305.676)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 83.1602 317.695)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 83.1562 329.715)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 83.1562 341.736)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 83.1562 353.756)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 83.1562 365.775)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 83.1562 377.797)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 83.1562 389.816)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 71.1406 305.676)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 71.1406 317.695)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 71.1406 329.715)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 71.1406 341.736)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 71.1406 353.756)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 71.1406 365.775)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 71.1406 377.797)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 71.1406 389.816)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 59.1211 305.676)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 59.1211 317.695)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 59.1172 329.715)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 59.1172 341.736)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 59.1172 353.756)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 59.1172 365.775)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 59.1172 377.797)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 59.1172 389.816)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 47.1016 305.676)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 47.1016 317.695)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 47.1016 329.715)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 47.1016 341.736)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 47.1016 353.756)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 47.1016 365.775)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 47.1016 377.797)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 47.1016 389.816)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 35.082 305.676)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 11.043 305.676)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 35.082 317.695)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 11.043 317.695)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 35.0781 329.715)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 11.0391 329.715)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 35.0781 341.736)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 11.0391 341.736)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 35.0781 353.756)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 11.0391 353.756)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 35.0781 365.775)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 11.0391 365.775)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 35.0781 377.797)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 11.0391 377.797)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 35.0781 389.816)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 11.0391 389.816)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 23.0625 305.676)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 23.0625 317.695)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 23.0625 329.715)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 23.0625 341.736)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 23.0625 353.756)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 23.0625 365.775)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 23.0625 377.797)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 23.0625 389.816)",
    fill: "white"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M202.401 337.552C221.077 337.552 236.256 352.83 236.256 371.711H300.802C300.802 316.869 256.754 272.426 202.401 272.426C148.048 272.426 104 316.869 104 371.711H168.547C168.547 352.867 183.688 337.552 202.401 337.552Z",
    fill: "#EE7F25"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_475_20666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 272,
    width: 197,
    height: 100
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M202.401 337.552C221.077 337.552 236.256 352.83 236.256 371.711H300.802C300.802 316.869 256.754 272.426 202.401 272.426C148.048 272.426 104 316.869 104 371.711H168.547C168.547 352.867 183.688 337.552 202.401 337.552Z",
    fill: "#EE7F25"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_475_20666)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 296.859 277.816)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 296.859 291.955)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 296.859 306.096)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 296.859 320.236)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 296.859 334.375)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 296.859 348.516)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 296.859 362.656)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 282.723 277.816)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 282.723 291.955)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 282.723 306.096)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 282.723 320.236)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 282.723 334.375)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 282.723 348.516)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 282.723 362.656)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 268.578 277.816)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 268.578 291.955)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 268.578 306.096)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 268.578 320.236)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 268.578 334.375)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 268.578 348.516)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 268.578 362.656)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 254.441 277.816)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 226.16 277.816)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 254.441 291.955)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 226.16 291.955)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 254.441 306.096)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 226.16 306.096)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 254.441 320.236)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 226.16 320.236)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 254.441 334.375)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 226.16 334.375)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 254.441 348.516)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 226.16 348.516)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 254.441 362.656)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 226.16 362.656)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 240.301 277.816)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 212.023 277.816)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 240.301 291.955)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 212.023 291.955)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 240.301 306.096)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 212.023 306.096)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 240.301 320.236)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 212.023 320.236)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 240.301 334.375)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 212.023 334.375)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 240.301 348.516)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 212.023 348.516)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 240.301 362.656)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1.01,
    cy: 1.01,
    r: 1.01,
    transform: "matrix(-1 0 0 1 212.023 362.656)",
    fill: "white"
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M168.547 164.869C168.547 146.026 183.688 130.711 202.401 130.711L202.401 65.584C148.048 65.584 104 110.028 104 164.869C104 219.711 148.048 264.154 202.401 264.154L202.401 199.028C183.725 199.028 168.547 183.75 168.547 164.869Z",
    fill: "#E43625"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_475_20666",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 104,
    y: 65,
    width: 98,
    height: 199
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M168.284 164.463C168.284 145.697 183.363 130.444 202 130.444L202 65.5831C147.868 65.5831 104 109.846 104 164.463C104 219.081 147.868 263.344 202 263.344L202 198.483C183.4 198.483 168.284 183.268 168.284 164.463Z",
    fill: "#6F368B"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_475_20666)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 -105.182L223.203 68.3156",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 -93.6152L223.203 79.882",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 -82.0488L223.203 91.4484",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 -70.4824L223.203 103.015",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 -58.916L223.203 114.581",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 -47.3496L223.203 126.148",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 -35.7832L223.203 137.714",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 -24.2168L223.203 149.28",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 -12.6504L223.203 160.847",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 -1.08399L223.203 172.413",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 10.4824L223.203 183.98",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 22.0488L223.203 195.546",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 33.6152L223.203 207.112",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 45.1816L223.203 218.679",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 56.748L223.203 230.245",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 68.3144L223.203 241.812",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 79.8809L223.203 253.378",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 91.4473L223.203 264.944",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 103.014L223.203 276.511",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 114.58L223.203 288.077",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 126.146L223.203 299.644",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 137.713L223.203 311.21",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 149.279L223.203 322.777",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 160.848L223.203 334.345",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 172.414L223.203 345.911",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 183.98L223.203 357.478",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 195.547L223.203 369.044",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 207.113L223.203 380.611",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 218.68L223.203 392.177",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 230.246L223.203 403.743",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 241.812L223.203 415.31",
    stroke: "#1F2A62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.7059 253.379L223.203 426.876",
    stroke: "#1F2A62"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecondSectionGraphic);
export default __webpack_public_path__ + "static/media/secondSectionGraphic.2dc07f1e8005fa36c0fb9b44b7595c24.svg";
export { ForwardRef as ReactComponent };